/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SellerLimitsDTO interface.
 */
export function instanceOfSellerLimitsDTO(value) {
    return true;
}
export function SellerLimitsDTOFromJSON(json) {
    return SellerLimitsDTOFromJSONTyped(json, false);
}
export function SellerLimitsDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'catalogProductLimit': json['catalogProductLimit'] == null ? undefined : json['catalogProductLimit'],
        'catalogProductUsed': json['catalogProductUsed'] == null ? undefined : json['catalogProductUsed'],
        'dailySearchAsinLimit': json['dailySearchAsinLimit'] == null ? undefined : json['dailySearchAsinLimit'],
        'dailySearchAsinUsed': json['dailySearchAsinUsed'] == null ? undefined : json['dailySearchAsinUsed'],
        'dailySearchResetsAt': json['dailySearchResetsAt'] == null ? undefined : (new Date(json['dailySearchResetsAt'])),
        'asinPoolLimit': json['asinPoolLimit'] == null ? undefined : json['asinPoolLimit'],
        'asinPoolUsed': json['asinPoolUsed'] == null ? undefined : json['asinPoolUsed'],
    };
}
export function SellerLimitsDTOToJSON(json) {
    return SellerLimitsDTOToJSONTyped(json, false);
}
export function SellerLimitsDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'catalogProductLimit': value['catalogProductLimit'],
        'catalogProductUsed': value['catalogProductUsed'],
        'dailySearchAsinLimit': value['dailySearchAsinLimit'],
        'dailySearchAsinUsed': value['dailySearchAsinUsed'],
        'dailySearchResetsAt': value['dailySearchResetsAt'] == null ? undefined : ((value['dailySearchResetsAt']).toISOString()),
        'asinPoolLimit': value['asinPoolLimit'],
        'asinPoolUsed': value['asinPoolUsed'],
    };
}
